import React from 'react';

export default function CategoryBar({ categories, activeCategory, setActiveCategory }) {
  return (
    <div style={categoryBarContainer}>
      {categories.map((cat) => (
        <button
          key={cat}
          onClick={() => setActiveCategory(cat)}
          style={activeCategory === cat ? activeCatBtn : catBtn}
        >
          {cat}
        </button>
      ))}
    </div>
  );
}

const categoryBarContainer = { display: 'flex', gap: '0.5rem', marginBottom: '1rem', overflowX: 'auto', paddingBottom: '0.25rem' };
const catBtn = { padding: '0.5rem 1.25rem', border: '1px solid #E5E7EB', background: '#FFF', borderRadius: '20px', color: '#374151', cursor: 'pointer', fontWeight: '500', whiteSpace: 'nowrap' };
const activeCatBtn = { ...catBtn, background: '#10B981', color: '#FFF', borderColor: '#10B981' };